import { render } from "./ApplicationErrorNotification.vue?vue&type=template&id=54ce9495&scoped=true&ts=true"
import script from "./ApplicationErrorNotification.vue?vue&type=script&lang=ts"
export * from "./ApplicationErrorNotification.vue?vue&type=script&lang=ts"

import "./ApplicationErrorNotification.vue?vue&type=style&index=0&id=54ce9495&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ce9495"]])

export default __exports__